export default "__VITE_ASSET__D6bA9kmk__"